import PropTypes from 'prop-types';

var propTypes = {
    label: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    imgUrl: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
    actions: PropTypes.arrayOf(PropTypes.object),
    className: PropTypes.string,
};
var defaultProps = {
    label: '',
    actions: [],
};

export { defaultProps, propTypes };
